<template>
    <div class="header">
        <div v-if="my_name">
            <div v-if="topOnly">
                <!-- 只显示右上角 -->
                <div class="current current1">
                    <span @click="openPop">当前登录：{{my_name}}</span>
                    <div class="switch" @click="openPop"></div>
                </div>
            </div>
            <div v-else>
                <div class="banner">
                    <div class="type">
                        <el-select v-model="gametypeid" placeholder="请选择游戏类型" popper-class="popper-scrollbar-show"
                           @change="choose_game">
                            <el-option v-for="item in gameList" :key="item.value" :label="item.label" :value="item.value"
                             ></el-option>
                        </el-select>
                    </div>
                    <div class="current">
                        <span @click="openPop">当前登录：{{my_name}}</span>
                        <div class="switch" @click="openPop"></div>
                    </div>
                    <div class="img">
                        <img :src="`https://cdn.09game.com/resources/item/dj_${head_id}_200.png`" alt v-if="head_id && head_id>1000" />
                        <img :src="`https://cdn.09game.com/resources/head/head_${head_id}_80.png`" alt v-else />
                    </div>
                </div>
                <div class="my-name">
                    {{name}}
                    <div class="search" @click="$router.push('/gamescore/search')" v-if="is_self"></div>
                </div>
                <div class="lv">
                    {{`Lv.${lv}`}}
                    <div class="back-self" @click="$router.push('/gamescore')" v-if="!is_self"></div>
                </div>
                <base-divider class="top-divider"></base-divider>
            </div>

            <el-dialog title :visible.sync="pop_show" class="switch-pop" v-if="pop_show" :close-on-click-modal="false">
                <div class="close" @click="closePop()"></div>
                <div class="title">请选择需要登录的昵称</div>
                <base-divider></base-divider>
                <ul class="name-ul" v-if="account_list.length>0">
                    <li class="name-li" v-for="(item, index) in account_list" :key="index">
                        <div class="img" @click="switch_account(item.user_id)">
                            <img :src="`https://cdn.09game.com/resources/item/dj_${item.avatar}_200.png`" alt v-if="item.avatar && item.avatar>1000" />
                            <img :src="`https://cdn.09game.com/resources/head/head_${item.avatar}_80.png`" alt v-else />
                        </div>
                        <div class="info">
                            <img :src="require(`@/assets/img/level/LV${item.vip_level}.png`)" alt />
                            <div class="name">{{item.user_name}}</div>
                        </div>
                    </li>
                </ul>
                <base-divider></base-divider>
                <div class="refresh">
                     <p>
                        可解除微信与当前账号的绑定
                        <span @click="refresh">立即解绑</span>
                    </p>
                </div>
            </el-dialog>
        </div>
        <div v-else>
            <div class="banner">
                <div class="img">
                    <img src="@/assets/img/logo.png" alt class="img-logo" />
                </div>
            </div>
            <div class="my-name name-df">09电竞平台</div>
            <base-divider class="top-divider"></base-divider>
        </div>
    </div>
</template>
<script>
export default {
    name: 'base-score-header',
    props: {
        head_id: {
            //需要默认值
            require: false,
            default: 0,
        },
        is_self: {
            require: false,
            default: true,
        },
        name: {
            require: false,
            default: '',
        },
        my_name: {
            require: false,
            default: '',
        },
        topOnly: {
            require: false,
        },
        lv: {
            require: false,
        },
        account_list: {
            require: false,
            default: () => [],
        },
    },
    created() {
        this.val = this.name
        //  console.log(this.lv);
    },
    data() {
        return {
            val: '',
            pop_show: false,
            timer: null,
            gametypeid: 1,
            gameList: [
                {
                    value: 1,
                    label: 'DOTA',
                },
                {
                    value: 2,
                    label: 'IM',
                },
                {
                    value: 21,
                    label: 'OMG',
                },
                {
                    value: 153,
                    label: 'Dota DS',
                },
            ],
            btn_lock: false,
        }
    },
    methods: {
        // 切换账号
        switch_account(user_id) {
            if(this.$storage.getOpenId() == null){
                this.$message.error('数据失效，请清空微信缓存重试！')
                return false
            }
            if(this.btn_lock) { return false }
            let token = this.$storage.getToken()
            if (token.split('-')[0] == user_id) {
                this.$message.error('不能切换至当前账号')
                return false
            }
            this.btn_lock = true;
            this.$http.setLoginByWx(token, user_id, this.$storage.getOpenId()).then((res) => {
                if (res.code == 0) {
                    this.btn_lock = false;
                    this.$message.success('切换成功')
                    this.closePop()
                    this.$storage.setAuth(res.token)
                    this.$storage.setToken(res.token)
                    if (this.$router.currentRoute.path === '/') {
                        this.$parent.init()
                    } else if (this.$router.currentRoute.path === '/gamescore'){
                        this.$router.push({path: '/gamescore', query: {date: new Date().getTime()}});
                    } else {
                        this.$router.push('/')
                    }
                } else {
                    this.btn_lock = false;
                    this.$message.error(res.err ? res.err : '切换失败')
                }
            })
        },
        // 刷新绑定状态
        refresh() {
            if (this.timer) {
                return false
            }
            if(this.$storage.getOpenId() == null){
                this.$message.error('数据失效，请清空微信缓存重试！')
                return false
            }
            this.$http.unlockWechat(this.$storage.getToken(), this.$storage.getOpenId()).then((res) => {
                if (res.code == 0 || res.code == 2) {
                    //微信已解绑
                   localStorage.clear()
                    if (this.$router.currentRoute.path === '/gamescore') {
                        this.$router.push({ path: '/auth_page', query: { fromPage: this.$router.currentRoute.path.slice(1) } })
                    } else {
                        this.$router.push('/auth_page')
                    }
                } else {
                    this.$message.error(res.msg ? res.msg : res.error ? res.error : '数据有误，请清空微信缓存重试！')
                    clearTimeout(this.timer)
                    this.timer = setTimeout(() => {
                        clearTimeout(this.timer)
                        this.timer = null
                    }, 3000)
                }
            })
        },
        openPop() {
            this.pop_show = true
        },
        closePop() {
            this.pop_show = false
        },
        // 选择游戏类型
        choose_game(val){
            // console.log('游戏id', val);
            this.$emit('click', val)
        },
        // emitter: function (user_id) {
        //     console.log(user_id);
        //     this.$emit('click', user_id)
        // },
    },
}
</script>
<style  lang="scss">
.popper-scrollbar-show {
    .el-scrollbar {
    > .el-scrollbar__bar.is-vertical  {
        display: block !important;
        // opacity: 1 !important;
    }
    }
}
// option选项 最外层
.el-select-dropdown {
    background: rgba(0, 0, 0, 0.8);
    border: 1px solid #c4a160;
    border-radius: 0.2rem;
    z-index: 9999;
}
// option选项 文字样式
.el-select-dropdown__item {
    height: 0.44rem;
    line-height: 0.44rem;
    color: #919191 !important;
    font-size: 0.22rem;
    z-index: 9999;
}
.el-select-dropdown__item.selected span {
    color: #ffebc6 !important;
    z-index: 9999;
}
// 移入option选项 样式调整
.el-select-dropdown__item.hover {
    background-color: rgba(255, 255, 255, 0.06);
    color: rgba(255, 255, 255, 0.8) !important;
    z-index: 9999;
}

// 下拉框垂直滚动条宽度
.el-scrollbar__bar.is-vertical {
    width: 10px;
    top: 2px;
}
// 下拉框最大高度
.el-select-dropdown__wrap {
    max-height: 200px;
}

.type {
    // 修改input默认值颜色 兼容其它主流浏览器
    input::-webkit-input-placeholder {
        color: rgba(255, 255, 255, 0.5);
    }
    input::-moz-input-placeholder {
        color: rgba(255, 255, 255, 0.5);
    }
    input::-ms-input-placeholder {
        color: rgba(255, 255, 255, 0.5);
    }
    // input框
    .el-select,
    .el-input,
    .el-input__inner {
        width: 1.92rem;
        height: 0.42rem;
        line-height: 0.42rem;
        background: rgba(0, 0, 0, 0.8);
        border-radius: 0.2rem;
        color: #ffebc6;
        font-size: 0.22rem;
        border-color: #c4a160; // 默认边框的颜色
        text-align: left;
    }

    // 鼠标悬浮时 input框颜色
    .el-input__inner:hover {
        background-color: rgba(255, 255, 255, 0.12);
    }

    // input框 右侧的箭头
    .el-select .el-input .el-select__caret {
        color: #b48f49;
        height: 0.42rem;
        line-height: 0.42rem;
    }

    // option选项 上面的箭头
    //     .el-popper[x-placement^="bottom"] .popper__arrow::after {
    //     border-bottom-color: rgba(43, 45, 55, 0.80);
    //     z-index: 9999;
    // }
    //     .popper__arrow {
    //     border: none;
    // }
}
.switch-pop {
    .el-dialog {
        width: 100%;
        padding: 0;
        margin: 0;
        margin-top: 0 !important;
        background: transparent !important;
        border-radius: 0;
        box-shadow: none !important;
        -webkit-box-shadow: none !important;

        .el-form {
            padding-right: 80px;
        }

        .el-dialog__header {
            padding: 0;
            margin: 0;
            // display: none;
            .el-dialog__title {
                font-size: 16px;
            }
            .el-dialog__headerbtn .el-dialog__close {
                font-size: 16px !important;
            }
        }
        .el-dialog__body {
            padding: 0;
            margin: 0;
            box-shadow: none;
            -webkit-box-shadow: none;
        }

        .el-dialog__footer {
            padding: 0;
            margin: 0;
        }
    }
}
</style>
<style lang="scss" scoped>
.header {
    // position: relative;
    // margin-bottom: .45rem;
    .current {
        width: 97%;
        height: 0.24rem;
        line-height: 0.24rem;
        text-align: right;
        padding-top: 0.23rem;
        color: #ffffff;
        font-size: 0.24rem;
        .switch {
            width: 0.24rem;
            height: 0.24rem;
            background: url(~@/assets/img/switch.png) 0 0 no-repeat;
            background-size: contain;
            display: inline-block;
            vertical-align: middle;
        }

        &.current1 {
            text-shadow: 0.01rem 0.01rem 0 #000000, -0.01rem -0.01rem 0 #000000, -0.01rem 0.01rem 0 #000000, 0.01rem -0.01rem 0 #000000;
        }
    }

    .banner {
        width: 100%;
        height: 2.01rem;
        background: url(~@/assets/img/top.png) 0 0 no-repeat;
        position: relative;
        background-size: cover;
        background-position: center bottom;

        .type {
            position: absolute;
            top: 0;
            left: 0.2rem;
        }

        .img {
            position: absolute;
            top: 0.98rem;
            left: 50%;
            transform: translateX(-50%);
            width: 1.9rem;
            height: 1.9rem;
            background: url(~@/assets/img/head-bg.png) 0 0 no-repeat;
            background-size: cover;
            img {
                width: 1.6rem;
                height: 1.6rem;
                border-radius: 50%;
                display: block;
                margin: 0.15rem;
                &.img-logo {
                    border-radius: 0;
                }
            }
        }
    }
    .my-name {
        width: 100%;
        font-size: 0.46rem;
        text-align: center;
        height: 0.45rem;
        line-height: 0.45rem;
        color: #212121;
        margin-top: 0.96rem;
        position: relative;
        .search {
            position: absolute;
            top: 0;
            right: 25%;
            width: 0.46rem;
            height: 0.46rem;
            background: url(~@/assets/img/search.png) 0 0 no-repeat;
            background-size: cover;
            &:hover {
                cursor: pointer;
                background-position-y: -0.46rem;
            }
        }
        &.name-df {
            font-size: 0.5rem;
            color: #c39b5e;
            font-weight: bold;
        }
    }
    .lv {
        position: relative;
        width: 100%;
        text-align: center;
        height: 0.21rem;
        line-height: 0.21rem;
        color: #6f6f6f;
        font-size: 0.26rem;
        margin-top: 0.16rem;
        .back-self {
            position: absolute;
            top: 0;
            right: 0.3rem;
            width: 1.59rem;
            height: 0.22rem;
            background: url(~@/assets/img/back1.png) 0 0 no-repeat;
            background-size: cover;
            &:hover {
                cursor: pointer;
                background-position-y: -0.22rem;
            }
        }
    }
    .top-divider {
        margin: 0.33rem 0;
    }
    .switch-pop {
        width: 6.24rem;
        height: 8.24rem;
        background: #ffffff;
        border-radius: 0.3rem;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        .close {
            position: absolute;
            top: 0.2rem;
            right: 0.2rem;
            width: 0.56rem;
            height: 0.56rem;
            background: url(~@/assets/img/close.png) 0 0 no-repeat;
            background-size: 100% auto;
            &:hover {
                cursor: pointer;
                background-position-y: -0.56rem;
            }
        }
        .title {
            width: 100%;
            font-size: 0.4rem;
            text-align: center;
            height: 1.2rem;
            font-weight: bold;
            line-height: 1.25rem;
            color: #c39b5e;
        }
        .name-ul {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-wrap: wrap;
            width: 100%;
            min-height: 5.5rem;
            margin-bottom: 0.5rem;
            .name-li {
                list-style: none;
                width: 2rem;
                margin: 0.35rem 0.34rem 0 0.34rem;
                .img {
                    width: 1.9rem;
                    height: 1.9rem;
                    background: url(~@/assets/img/head-bg.png) 0 0 no-repeat;
                    background-size: cover;
                    margin: 0 auto;
                    padding-top: 0.15rem;
                    img {
                        width: 1.6rem;
                        height: 1.6rem;
                        border-radius: 50%;
                        display: block;
                        margin: 0 0.15rem 0.15rem 0.15rem;
                    }
                }

                .info {
                    width: 100%;
                    height: 0.34rem;
                    line-height: 0.34rem;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin-top: 0.18rem;
                    img {
                        width: 0.34rem;
                        height: 0.34rem;
                        margin-right: 0.09rem;
                        img {
                            width: 0.34rem;
                            height: 0.34rem;
                            display: block;
                        }
                    }
                    .name {
                        color: #2e2e2e;
                        font-size: 0.28rem;
                        font-weight: bold;
                        height: 0.34rem;
                        line-height: 0.34rem;
                    }
                }
            }
        }

        .refresh {
            width: 96%;
            margin: 0 auto;
            height: 0.6rem;
            p {
                width: 100%;
                font-size: 0.26rem;
                text-align: center;
                height: 0.6rem;
                line-height: 0.6rem;
                color: #c39b5e;
                span {
                    display: inline-block;
                    color: #2f92eb;
                    text-decoration: underline;
                    padding-left: .15rem;
                    :hover {
                        cursor: pointer;
                        color: #00427e;
                    }
                }
            }
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/components/BaseScoreHeader.vue